import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { Section, Eyebrow, Heading } from '../Section';
import { CTAButton } from '../CTAButton';
import { faqs } from '../../data/testimonials';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section tone="darker" data-id="element-101" data-mp="121trvjs5msuk">
      <Eyebrow data-id="element-102" data-mp="12354m93kvaxt">❓ Before you decide</Eyebrow>
      <Heading data-id="element-103" data-mp="1ps7olnlopfvh">Frequently asked questions</Heading>

      <div className="mt-8 space-y-3" data-id="element-104" data-mp="1pspr31yxwqbu">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <div key={faq.question} className="overflow-hidden rounded-xl border border-white/10 bg-navy-900" data-id="element-105" data-mp="1g2e9icmc2imh" data-mpi={index}>
              <h3 data-id="element-106" data-mp="1kzwl6arqjby6">
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left" data-id="element-107" data-mp="1kzeh4rytztfp">
                  <span className="text-[15px] font-bold leading-snug text-white sm:text-lg" data-id="element-108" data-mp="2oqqmjedeuhgz">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-500 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-109" data-mp="2ygjzojt7b4nc" />
                </button>
              </h3>
              {isOpen ? <div className="space-y-2 border-t border-white/10 px-4 py-4" data-id="element-110" data-mp="32h3zjv55smd6">
                  {faq.answer.map(paragraph => <p key={paragraph} className="text-[14px] leading-relaxed text-white/80 sm:text-base" data-id="element-111" data-mp="3cftfhidhvwqs">
                      {paragraph}
                    </p>)}
                </div> : null}
            </div>;
      })}
      </div>

      <div className="mt-8" data-id="element-112" data-mp="27qz8s3wqzkob">
        <CTAButton label="I’m ready — give me access" data-id="element-113" data-mp="27rqtgjot3xzt" />
      </div>
    </Section>;
}